import { Reveal, Overline, Hairline } from "./primitives";
import { ASSETS } from "../../config";

const STEPS = [
  "Siamo Elio e Chiara: marito e moglie, discepoli di Gesù e fondatori di Fede & Fitness Italia.",
  "Elio è passato da 108 a 75 chili. Ma quei chili raccontano soltanto una parte della trasformazione. Nella sua storia ci sono un corpo trascurato, attacchi di panico, pornografia, droga e la difficoltà di chiedere aiuto. Ci sono stati momenti senza una direzione e scelte da rimettere in discussione.",
  "Come coppia abbiamo attraversato dolore e perdita, anche la perdita di nostra figlia durante la gravidanza. Abbiamo dovuto imparare a sostenerci e ricominciare.",
  "Nel 2024 è iniziato il cammino di conversione di Elio. Seguendo Gesù abbiamo cominciato a portare la fede nel matrimonio, nel rapporto con il corpo e nelle responsabilità quotidiane.",
  "Allenamento e alimentazione hanno avuto un ruolo importante. Il cambiamento ha coinvolto anche identità, pensieri, abitudini e relazioni.",
  "Alla nostra esperienza abbiamo affiancato le competenze di life e fitness coaching e, negli ultimi due anni, lo studio delle Sacre Scritture e l'approfondimento del coaching cristiano. Da questo cammino sono nati Fede & Fitness Italia e il Metodo Tempio Vivo.",
];

const Cross = () => (
  <svg viewBox="0 0 24 36" className="h-8 w-5 text-gold" fill="currentColor" aria-hidden>
    <rect x="10" y="0" width="4" height="36" rx="1" />
    <rect x="2" y="8" width="20" height="4" rx="1" />
  </svg>
);

export const StorySection = () => (
  <section id="storia" className="relative bg-white/[0.02] py-28 sm:py-40" data-testid="story-section">
    <Hairline className="absolute inset-x-0 top-0" />
    <div className="mx-auto max-w-6xl px-6 sm:px-8">
      <Reveal className="max-w-3xl">
        <Overline>La storia di Elio e Chiara</Overline>
        <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.02] tracking-tight text-white">
          La nostra storia è il motivo per cui{" "}
          <span className="italic text-gold">abbiamo creato questo spazio.</span>
        </h2>
        <div className="mt-8 space-y-4 text-base sm:text-lg font-light leading-relaxed text-white/75">
          <p>
            Siamo Elio e Chiara, fondatori di Fede & Fitness Italia. Anche noi abbiamo attraversato
            battaglie, smarrimento, dolore, cadute e stagioni di trasformazione.
          </p>
          <p>
            Il nostro incontro con Cristo ha cambiato radicalmente il modo in cui guardiamo la
            vita, l'identità, il corpo, le relazioni e il futuro.
          </p>
          <p className="text-white">
            La Mappa del Tempio nasce anche da questo: dal desiderio di offrire ad altre persone
            uno spazio vero in cui sentirsi ascoltate e iniziare a fare chiarezza.
          </p>
        </div>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-14 lg:grid-cols-12">
        <div className="order-last lg:order-first lg:col-span-5">
          <Reveal>
            <div
              className="overflow-hidden rounded-2xl border border-white/15"
              data-testid="story-photo-couple"
            >
              <img
                src={ASSETS.coupleSelfie}
                alt="Elio e Chiara insieme"
                className="aspect-[3/4] w-full object-cover object-top"
              />
            </div>
            <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-gold">
              Elio & Chiara — oggi
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 grid grid-cols-2 gap-4" data-testid="story-transformation">
              <div>
                <div className="overflow-hidden rounded-2xl border border-white/15">
                  <img
                    src={ASSETS.elioBefore}
                    alt="Elio prima del percorso — 108 chili"
                    className="aspect-[3/4] w-full object-cover object-top"
                  />
                </div>
                <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-white/50">
                  Elio · 108 kg
                </p>
              </div>
              <div>
                <div className="overflow-hidden rounded-2xl border-2 border-gold/60 shadow-[0_0_40px_-14px_rgba(255,211,77,0.5)]">
                  <img
                    src={ASSETS.elioAfter}
                    alt="Elio oggi — 75 chili"
                    className="aspect-[3/4] w-full object-cover object-top"
                  />
                </div>
                <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-gold">
                  Elio · 75 kg oggi
                </p>
              </div>
              <div>
                <div className="overflow-hidden rounded-2xl border border-white/15">
                  <img
                    src={ASSETS.chiaraBefore}
                    alt="Chiara nel momento più duro"
                    className="aspect-[3/4] w-full object-cover object-top"
                  />
                </div>
                <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-white/50">
                  Chiara · il momento più duro
                </p>
              </div>
              <div>
                <div className="overflow-hidden rounded-2xl border-2 border-gold/60 shadow-[0_0_40px_-14px_rgba(255,211,77,0.5)]">
                  <img
                    src={ASSETS.chiaraAfter}
                    alt="Chiara oggi"
                    className="aspect-[3/4] w-full object-cover object-top"
                  />
                </div>
                <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.25em] text-gold">
                  Chiara · oggi
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <div className="relative border-l border-gold/30 pl-8 sm:pl-12">
            {STEPS.map((s, i) => (
              <Reveal key={i} delay={i * 0.05}>
                <div className="relative pb-10 last:pb-0">
                  <span
                    className="absolute -left-[37px] top-2 h-2.5 w-2.5 rounded-full bg-gold shadow-[0_0_12px_rgba(255,211,77,0.7)] sm:-left-[53px]"
                    aria-hidden
                  />
                  <p className="text-base sm:text-lg font-light leading-relaxed text-white/80">
                    {s}
                  </p>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.2}>
              <div className="mt-4 flex items-center gap-4">
                <Cross />
                <p className="font-serif text-xl sm:text-2xl font-light italic text-gold">
                  La prima testimonianza di questo metodo siamo noi.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  </section>
);
